// @flow
import React from 'react'
import Helmet from 'react-helmet'
import { connect } from 'react-redux'
import { openContactModal } from '../../actions/modals'
import LinkButton from '../../components/LinkButton'

type Props = {
  openContactModal: Function
}

const TermsOfService = (
  { openContactModal }: Props // eslint-disable-line no-shadow
) => (
  <div style={{ padding: '4rem 0' }}>
    <Helmet title="Terms of Service" />
    <div className="container">
      <p>
        These Terms of Use and the Kief Realty Privacy Policy were updated on
        January 1, 2017. Your continued use of the Services constitutes your
        acceptance of the updated policies.
      </p>
      <h5>MLS Terms of Use</h5>
      <p>
        Before we can show you pictures and prices of sold homes, or show you
        certain information on active listings from Kief Realty Agents, we
        require you to acknowledge that you&apos;re considering Kief Realty as
        your real estate brokerage.
      </p>
      <p>
        We know that sounds somewhat intimidating, but remember: you have no
        obligation to work with a Kief Realty Agent to buy or sell a home. You
        can choose to work with us or not.
      </p>
      <ul>
        <li>
          You are entering into a lawful consumer-broker relationship with Kief
          Realty as defined by applicable state law.
        </li>
        <li>
          You have no obligation to work with Kief Realty and you can terminate
          your account with us any time. Any information you obtain from the
          Kief Realty website is intended for your personal, non-commercial use.
        </li>
        <li>
          You have a bona fide interest in the purchase, sale, or lease of real
          estate on the Kief Realty website.
        </li>
        <li>
          You will not copy, redistribute, or retransmit any of the information
          provided except in connection with your consideration of the purchase
          or sale of an individual property.
        </li>
        <li>
          You acknowledge that the individual multiple listing service (MLS),
          which supplies the listing data, owns such data and you acknowledge
          the validity of the MLS&apos;s copyright to such data.
        </li>
        <li>
          Kief Realty also explicitly authorizes MLS employees, MLS members, or
          their duly authorized representatives to access Kief Realty&apos;s
          website for the purposes of verifying compliance with MLS rules and
          monitoring the display of Participants&apos; listings on Kief
          Realty&apos;s site.
        </li>
      </ul>
      <p>
        In addition to the above terms, registered users also agree to the Kief
        Realty Terms of Use and Privacy Policy, which apply to all users of the
        Kief Realty website.
      </p>
      <p>
        Welcome to kiefrealty.com. This website and the Kief Realty Applications
        (as defined below)(the &ldquo;Sites&rdquo;), together with the services
        provided through the Sites (collectively the Sites and services are the
        &ldquo;Services&rdquo;) are owned and operated by Kief Realty, a
        technology-powered real estate brokerage located at 311 West Oak Street,
        Paxton IL 60957 (&ldquo;Kief Realty&rdquo;). These Terms of Use which
        include the Kief Realty Privacy Policy, serve as the
        &rdquo;Agreement&rdquo; between you and Kief Realty regarding the
        Services, and provide important information to you, including
        information about your obligations about content and our limitation of
        liability to you. By accessing, downloading, or using any portion of the
        Services, you signify that you accept the terms of the Agreement. If you
        do not accept, then please do not use the Services.
      </p>
      <p>
        <em>
          If you want to list your home with a Kief Realty Agent, or buy a home
          with a Kief Realty Agent, then you will need to enter into a listing
          agreement or buyer agency agreement to become a Kief Realty Client;
          these agreements are not covered here.
        </em>
      </p>
      <h5>1. Who Can Use the Kief Realty Services</h5>
      <p>
        You must be: a) at least the age of majority in the state where you live
        to use the Sites, and b) a resident of the United States. If you are
        under 13 years old, do not use the Sites.
      </p>
      <h5>2. Intellectual Property Ownership and License</h5>
      <p>
        <u style={{ marginRight: '4px' }}>A. Copyright</u>
        <span>
          All materials (including source code, data, images, and other content)
          contained in the Services, including the selection and arrangement of
          the materials, are owned by Kief Realty or are licensed by Kief Realty
          for use on the Sites. Our site features Google Maps, please review
          their privacy policy, legal notices and terms of use. Portions of this
          page are modifications based on work created and shared by Google and
          used according to terms described in the Creative Commons 3.0
          Attribution License.
        </span>
      </p>
      <p>
        <u style={{ marginRight: '4px' }}>B. Trademarks</u>
        <span>
          Kief Realty, the Kief Realty logos and other Kief Realty trademarks,
          service marks, graphics, and logos used in connection with Kief Realty
          are trademarks or registered trademarks of Kief Realty in the United
          States. Apple, the Apple logo, iPad, iPhone, and iPod touch are
          trademarks of Apple Inc., registered in the U.S. and other countries.
          App Store is a service mark of Apple Inc. Android is a trademark of
          Google Inc. Use of this trademark is subject to Google Permissions.
          Other trademarks and logos used in connection with Kief Realty may be
          the trademarks of their respective owners.
        </span>
      </p>
      <p>
        <u style={{ marginRight: '4px' }}>C. Data</u>
        <span>
          The MLS Data on our Sites is the property of the individual MLSs
          providing the data. These MLSs have granted Kief Realty the necessary
          licenses to display the MLS Data on the Sites. Some require us to
          display certain licensing information about their MLS Data; this
          information can be found in Section 14 below.
        </span>
      </p>
      <p>
        <u style={{ marginRight: '4px' }}>D. Other Intellectual Property</u>
        <span>
          Kief Realty also owns trade secrets and know-how that contribute to
          the functionality of the Services.
        </span>
      </p>
      <p>
        <u style={{ marginRight: '4px' }}>
          E. Webscraping of Listing & Property Data Is Not Allowed
        </u>
        <span>
          Crawling the kiefrealty.com and network sites is allowed for inclusion
          in web search engine results only. Webscraping, downloading or
          webcrawling of any property or other data for inclusion in another
          real estate search site, content aggregator, or any other purpose is
          strictly forbidden without prior written consent from Kief Realty.
        </span>
      </p>
      <p>
        <u style={{ marginRight: '4px' }}>F. Restrictions</u>
        <span>
          Except as enabled and directed on the Services, you may not modify,
          decompile, reproduce, redistribute, attempt to commercially gain from
          your use, or misuse of the Services or any of their components. You
          may not use any meta-tags or other hidden text using the Kief Realty
          name or trademarks without our specific permission. We may revoke your
          permission to access and use the Sites, and we may block or prevent
          you from accessing the Sites, in our discretion without notice. If you
          violate the Terms of Use, your permission to access and use the Sites
          is automatically revoked.
        </span>
      </p>
      <p>
        <u style={{ marginRight: '4px' }}>G. Reservation of Rights</u>
        <span>
          Except for the limited license granted above, Kief Realty reserves all
          of its intellectual property rights in the Sites. This Agreement does
          not grant you any right or license with respect to any trademarks and
          logos.
        </span>
      </p>
      <p>
        <u style={{ marginRight: '4px' }}>H. Information Aggregation</u>
        <span>
          Kief Realty is not responsible for any errors in displayed information
          or delays in displaying information. All information on the Sites is
          either transmitted to Kief Realty from other entities or persons or
          was obtained through publicly available government sources. Issues of
          data accuracy may be brought to the attention of Kief Realty by
          sending feedback but it is likely that such information accuracy
          cannot be corrected by Kief Realty and the entity or person that
          generated the information must be appealed to. For example: incorrect
          listing information can only be changed by the third party listing
          agent under our terms with the MLSs.
        </span>
      </p>
      <p>
        <u style={{ marginRight: '4px' }}>I. Days on Kief Realty</u>
        <span>
          The days listed value on Kief Realty is derived from data in the MLS
          listing.
        </span>
      </p>
      <p>
        <u style={{ marginRight: '4px' }}>J. School Ratings & Review</u>
        <span>GreatSchools ratings provided by GreatSchools.net.</span>
      </p>
      <h5>3. Registration</h5>
      <p>
        You must register for a Kief Realty account to gain access to certain
        features. You must register to save favorites, receive listing alerts,
        initiate offers, etc. By registering for a Kief Realty account, you are
        agreeing to these Terms of Use as well as the MLS Terms of Use. You are
        responsible for all activities related to the Services that occur
        through your account and password. It is your responsibility to keep
        your Kief Realty profile information accurate. You agree to keep your
        password confidential, not use others&apos; accounts, nor permit others
        to use your account. Kief Realty reserves the right to terminate
        accounts at its discretion.
      </p>
      <h5>4. Equal Housing Opportunity</h5>
      <p>
        We are pledged to the letter and spirit of U.S. policy for the
        achievement of equal housing opportunity throughout the Nation. We
        encourage and support an affirmative advertising and marketing program
        in which there are no barriers to obtaining housing because of race,
        color, religion, sex, handicap, familial status, or national origin.
      </p>
      <h5>5. How Kief Realty May Communicate with You</h5>
      <p>
        For purposes of responding to you and providing you with information and
        notices about your account or the Services (such as information about
        homes you might be interested in), you agree that Kief Realty may
        communicate with you through the contact information associated with
        your Kief Realty account or Kief Realty Applications, including your
        device ID, email, mobile number, telephone, or the postal address you
        provided (if any). Please review your Account Settings or settings on
        your mobile device to control what kind of messages you receive from
        Kief Realty. Kief Realty has no liability rising from your failure to
        maintain accurate contact or other information, including, but not
        limited to, your failure to receive critical information about the
        Services. Through the Services, you can make requests for home tours,
        real estate agent contact, help selling or buying a home or other
        requests. By making those requests, you authorize Kief Realty to share
        your personal information including your home search history, favorites
        and saved searches, with a real estate professional (a Kief Realty Agent
        or staff member, or a Referral Agent, as defined below). When you make
        such a request to Kief Realty you are extending an express invitation
        for Kief Realty, or another appropriate entity or person, to contact
        you. A Referral Agent is employed by or works with another brokerage,
        but has teamed up with us to provide Kief Realty-quality service to a
        wider range of customers. We&apos;ll refer you to a Referral Agent in
        our discretion.
      </p>
      <h5>6. Third Party Sites</h5>
      <p>
        Kief Realty may include links to third party websites (&ldquo;Third
        Party Sites&rdquo;) in its Services. You should review any applicable
        terms or privacy policy of a Third Party Site before using it or sharing
        any information with it, because you may give the third-party permission
        to use your information in ways we would not. Kief Realty is not
        responsible for and does not endorse any features, content, advertising,
        products or other materials on or available from Third Party Sites.
      </p>
      <h5>7. Kief Realty Applications</h5>
      <p>
        Kief Realty offers services through applications built using Kief
        Realty&apos;s platform (&ldquo;Kief Realty Applications&rdquo;).
        Examples of Kief Realty Applications include, without limitation, its
        smart phone features, and Kief Realty &ldquo;Share&ldquo; buttons, which
        allow you to share your activities on the Sites with your friends using
        social media or email. You acknowledge you are responsible for all
        charges and necessary permissions related to accessing Kief Realty
        through your mobile access provider.
      </p>
      <h5>8. Termination</h5>
      <p>
        You may deactivate your account at any time. After you deactivate your
        account, you will no longer have access to the Services. If you&apos;d
        like to deactivate your account, please send us an email or contact
        through the Sites. Kief may terminate this Agreement or your account at
        any time, with or without notice.
      </p>
      <h5>9. Indemnification</h5>
      <p>
        You agree to indemnify Kief Realty and hold Kief Realty harmless for all
        damages, losses and costs (including, but not limited to, reasonable
        attorneys&apos; fees and costs) related to all third party claims,
        charges, and investigations, caused by (a) your failure to comply with
        this Agreement, including, without limitation, your submission of
        content that violates third party rights or applicable laws, (b) any
        Submissions or information you provide to the Services, and/or (c) any
        activity in which you engage on the Kief Realty Sites or using the Kief
        Realty Services.
      </p>
      <h5>10. Disclaimers</h5>
      <p>
        KIEF REALTY PROVIDES THE SERVICES ON AN &ldquo;AS IS&ldquo; AND
        &ldquo;AS AVAILABLE&ldquo; BASIS. KIEF REALTY DOES NOT CONTROL OR VET
        USER GENERATED CONTENT FOR ACCURACY. WE DO NOT PROVIDE ANY EXPRESS
        WARRANTIES OR REPRESENTATIONS. TO THE FULLEST EXTENT PERMISSIBLE UNDER
        APPLICABLE LAW, KIEF REALTY AND ITS SUPPLIERS DISCLAIM ANY AND ALL
        IMPLIED WARRANTIES AND REPRESENTATIONS, INCLUDING, WITHOUT LIMITATION,
        ANY WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE,
        TITLE, ACCURACY OF DATA, AND NONINFRINGEMENT. IF YOU ARE DISSATISFIED OR
        HARMED BY KIEF REALTY OR ANYTHING RELATED TO KIEF REALTY, YOU MAY
        DEACTIVATE YOUR KIEF REALTY ACCOUNT AND TERMINATE THIS AGREEMENT IN
        ACCORDANCE WITH SECTION 8 (&ldquo;TERMINATION&ldquo;) AND SUCH
        TERMINATION SHALL BE YOUR SOLE AND EXCLUSIVE REMEDY. KIEF REALTY IS NOT
        RESPONSIBLE, AND MAKES NO REPRESENTATIONS OR WARRANTIES FOR THE DELIVERY
        OF ANY MESSAGES (SUCH AS POSTING OF ANSWERS OR TRANSMISSION OF ANY OTHER
        USER GENERATED CONTENT) SENT THROUGH KIEF REALTY TO ANYONE. ANY
        MATERIAL, SERVICE, OR TECHNOLOGY DESCRIBED OR USED ON THE SITES MAY BE
        SUBJECT TO INTELLECTUAL PROPERTY RIGHTS OWNED BY THIRD PARTIES WHO HAVE
        LICENSED SUCH MATERIAL, SERVICE, OR TECHNOLOGY TO US. KIEF REALTY DOES
        NOT HAVE ANY OBLIGATION TO VERIFY THE IDENTITY OF THE PERSONS
        SUBSCRIBING TO ITS SERVICES, NOR DOES IT HAVE ANY OBLIGATION TO MONITOR
        THE USE OF ITS SERVICES BY OTHER USERS OF THE COMMUNITY; THEREFORE, KIEF
        REALTY DISCLAIMS ALL LIABILITY FOR IDENTITY THEFT OR ANY OTHER MISUSE OF
        YOUR IDENTITY OR INFORMATION BY OTHERS. KIEF REALTY DOES NOT GUARANTEE
        THAT THE SERVICES IT PROVIDES WILL FUNCTION WITHOUT INTERRUPTION OR
        ERRORS IN FUNCTIONING. THE OPERATION OF THE SERVICES MAY BE INTERRUPTED
        DUE TO MAINTENANCE, UPDATES, OR SYSTEM OR NETWORK FAILURES. KIEF REALTY
        DISCLAIMS ALL LIABILITY FOR DAMAGES CAUSED BY ANY SUCH INTERRUPTION OR
        ERRORS IN FUNCTIONING. FURTHERMORE, KIEF REALTY DISCLAIMS ALL LIABILITY
        FOR ANY MALFUNCTIONING, IMPOSSIBILITY OF ACCESS, OR POOR USE CONDITIONS
        OF THE SITES DUE TO INAPPROPRIATE EQUIPMENT, DISTURBANCES RELATED TO
        INTERNET SERVICE PROVIDERS, TO THE SATURATION OF THE INTERNET NETWORK,
        AND FOR ANY OTHER REASON. SOME JURISDICTIONS DO NOT ALLOW THE DISCLAIMER
        OF IMPLIED TERMS IN CONTRACTS WITH CONSUMERS AND AS A RESULT THE
        CONTENTS OF THIS SECTION MAY NOT APPLY TO YOU.
      </p>
      <h5>11. Limitation of Liability</h5>
      <p>
        IN NO EVENT WILL KIEF REALTY OR ANY SUPPLIER BE LIABLE FOR ANY DAMAGES,
        INCLUDING WITHOUT LIMITATION ANY INDIRECT, CONSEQUENTIAL, SPECIAL,
        INCIDENTAL, OR PUNITIVE DAMAGES ARISING OUT OF, BASED ON, OR RESULTING
        FROM THESE TERMS OF USE OR YOUR USE OF THE SERVICES, EVEN IF SUCH PARTY
        HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. THE EXCLUSION OF
        DAMAGES UNDER THIS PARAGRAPH IS INDEPENDENT OF YOUR EXCLUSIVE REMEDY SET
        FORTH BELOW AND SURVIVES IN THE EVENT SUCH REMEDY FAILS OF ITS ESSENTIAL
        PURPOSE OR IS OTHERWISE DEEMED UNENFORCEABLE. THESE LIMITATIONS AND
        EXCLUSIONS APPLY WITHOUT REGARD TO WHETHER THE DAMAGES ARISE FROM (A)
        BREACH OF CONTRACT, (B) BREACH OF WARRANTY, (C) NEGLIGENCE, OR (D) ANY
        OTHER CAUSE OF ACTION, TO THE EXTENT SUCH EXCLUSION AND LIMITATIONS ARE
        NOT PROHIBITED BY APPLICABLE LAW. IF YOU DO NOT AGREE WITH ANY PART OF
        THESE TERMS OF USE, OR YOU HAVE ANY DISPUTE OR CLAIM AGAINST KIEF REALTY
        OR ITS SUPPLIERS WITH RESPECT TO THESE TERMS OF USE OR THE SERVICES,
        THEN YOUR SOLE AND EXCLUSIVE REMEDY IS TO DISCONTINUE USING THE
        SERVICES.
      </p>
      <h5>12. Dispute Resolution</h5>
      <p>
        Any claim or controversy arising out of or relating to the use of the
        Sites, to the goods or services provided by Kief Realty, or to any acts
        or omissions for which you may contend Kief Realty is liable, including
        but not limited to any claim or controversy as to arbitrability
        (&ldquo;Dispute&ldquo;), shall be finally, and exclusively, settled by
        arbitration. The arbitration shall be held before one arbitrator under
        the commercial arbitration rules of the American Arbitration Association
        (&ldquo;AAA&ldquo;) in force at that time. The arbitration shall be
        venued in Illinois. The arbitrator shall be selected pursuant to the AAA
        rules or from a list of arbitrators provided by Kief Realty. Filing and
        other non-award costs will be paid for, in equal shares, by both parties
        except that the fee to the arbitrator will be paid by the non-prevailing
        party. To begin the arbitration process, a party must make a written
        demand. Should any State or Federal law conflict with the above rules
        for resolving disputes or the AAA rules, such conflicting rules shall be
        severed from the enforceable rules and the enforceable rules shall
        survive and control the dispute resolution process. Any gaps left in the
        process due to severed rules shall be resolved at the discretion of the
        selected arbitrator. Any judgment upon the award rendered by the
        arbitrators may be entered in any court of competent jurisdiction in
        Illinois. The arbitrators shall not have the power to award damages in
        connection with any Dispute in excess of actual compensatory damages and
        shall not multiply actual damages or award consequential, punitive or
        exemplary damages, and each party irrevocably waives any claim thereto.
        The agreement to arbitrate shall not be construed as an agreement to the
        joinder or consolidation of an arbitration under this agreement with
        arbitration of disputes or claims of any non-party, regardless of the
        nature of the issues or disputes involved.
      </p>
      <p>
        Should a Dispute arise and should the arbitration provisions herein
        become inapplicable or unenforceable, or in any instance of any lawsuit
        between you and Kief Realty, the parties agree that jurisdiction over
        and venue of any suit shall be exclusively in the state and federal
        courts sitting in Illinois. If either party employs attorneys to enforce
        any right in connection with any Dispute or lawsuit the prevailing party
        shall be entitled to recover reasonable attorneys&apos; fees.
      </p>
      <h5>13. Additional Legal Terms</h5>
      <p>
        <u style={{ marginRight: '4px' }}>A. Severability</u>
        <span>
          If any provision of this Agreement is found by a court of competent
          jurisdiction or arbitrator to be illegal, void, or unenforceable, the
          unenforceable provision will be modified so as to render it
          enforceable and effective to the maximum extent possible in order to
          effect the intention of the provision.
        </span>
      </p>
      <p>
        <u style={{ marginRight: '4px' }}>B. Notices</u>
        <span>
          You may contact us{' '}
          <LinkButton onClick={openContactModal}>here</LinkButton>. Or via mail
          or courier at: Kief Realty, 311 West Oak Street, Paxton IL 60957.
        </span>
      </p>
      <p>
        <u style={{ marginRight: '4px' }}>C. Entire Agreement</u>
        <span>
          You agree that this Agreement constitutes the entire, complete and
          exclusive agreement between you and Kief Realty regarding the Services
          and supersedes all prior agreements and understandings, whether
          written or oral, or whether established by custom, practice, policy or
          precedent, with respect to the subject matter of this Agreement. You
          also may be subject to additional terms and conditions that may apply
          when you use or purchase certain other Kief Realty services.
        </span>
      </p>
      <p>
        <u style={{ marginRight: '4px' }}>D. Amendments to This Agreement</u>
        <span>
          We reserve the right to modify, supplement, or replace the terms of
          this Agreement, effective prospectively upon posting at kiefrealty.com
          or notifying you otherwise. For example, we may present a notification
          on the Services when we have materially amended this Agreement or the
          Privacy Policy so that you may access and review the changes prior to
          your continued use of the Services. If you do not want to agree to
          changes to this Agreement, you can terminate this Agreement at any
          time per Section 8 (Termination).
        </span>
      </p>
      <p>
        <u style={{ marginRight: '4px' }}>E. No Waiver</u>
        <span>
          Our failure to act with respect to a breach of this Agreement by you
          or others does not waive our right to act with respect to that breach
          or subsequent similar or other breaches.
        </span>
      </p>
      <p>
        <u style={{ marginRight: '4px' }}>F. No Injunctive Relief</u>
        <span>
          In no event shall you seek or be entitled to rescission, injunctive or
          other equitable relief, or to enjoin or restrain the operation of the
          Services.
        </span>
      </p>
      <p>
        <u style={{ marginRight: '4px' }}>G. Assignment and Delegation</u>
        <span>
          You may not assign or delegate any rights or obligations under the
          Agreement. Any purported assignment and delegation shall be
          ineffective. We may freely assign or delegate all rights and
          obligations under the Agreement, fully or partially without notice to
          you. We may also substitute, by way of unilateral novation, effective
          upon notice to you, Kief Realty for any third party that assumes our
          rights and obligations under this Agreement.
        </span>
      </p>
      <p>
        <u style={{ marginRight: '4px' }}>H. Alpha and Beta Testing</u>
        <span>
          The Services include any alpha or beta testing or other evaluation or
          use of products and services, features, functionality, and all
          components thereof (whether in final or prerelease form) that we may
          conduct (&ldquo;Testing&rdquo;). Except to the extent otherwise
          provided in another agreement between you and Kief Realty, your
          participation in any Testing and use of any content, information, or
          other materials in connection with such Testing shall be subject to
          this Agreement.
        </span>
      </p>
      <p>
        <u style={{ marginRight: '4px' }}>
          I. Potential Other Rights and Obligations
        </u>
        <span>
          You may have rights or obligations under local law other than those
          enumerated here if you are located outside the United States.
        </span>
      </p>
      <p>
        <u style={{ marginRight: '4px' }}>
          J. Complaints Regarding Content Posted on the Kief Realty Website
        </u>
        <span>
          For non-copyright complaints, you may notify us{' '}
          <LinkButton onClick={openContactModal}>here</LinkButton>.
        </span>
      </p>
      <p>
        <u style={{ marginRight: '4px' }}>K. International Matters</u>
        <span>
          Kief Realty is controlled and operated from Kief Realty&apos;s United
          States offices in Illinois. We make no representation that the
          Services are appropriate or available for use in any particular
          location. Those who choose to access Kief Realty, do so on their own
          initiative and are responsible for compliance with local laws, if and
          to the extent local laws are applicable. The Services, including
          software from Kief Realty, is further subject to United States export
          controls. No Services, including software from Kief Realty, may be
          downloaded or otherwise exported or re-exported in violation of any
          applicable law, rule or regulation.
        </span>
      </p>
      <p>
        <u style={{ marginRight: '4px' }}>
          L. Complaint Regarding Copyright Infringement
        </u>
        <span>
          If you are a copyright holder and believe your work has been used on
          the Sites in a way that constitutes copyright infringement, please
          contact us with the following information:
        </span>
      </p>
      <ul>
        <li>
          Your name, address, phone number, and email address, so that we can
          reach you;
        </li>
        <li>
          Identification of the copyrighted work(s) you believe to be infringed;
        </li>
        <li>
          Identification of the material on the Sites you believe is infringing,
          including a location description (e.g., a URL);
        </li>
        <li>
          A statement, made under penalty of perjury, that you are the copyright
          owner or are authorized to act on the copyright owner&apos;s behalf,
          and that the information you provided is accurate;
        </li>
        <li>
          A statement that you have a good-faith belief the disputed use is not
          authorized by the copyright owner, its agent, or the law;
        </li>
        <li>A physical or electronic signature; and</li>
        <li>Send your infringement notices to:</li>
      </ul>
      <div style={{ marginBottom: '1rem' }}>
        <span>Kief Realty</span>
        <br />
        <span>311 West Oak Street</span>
        <br />
        <span>Paxton, IL 60957</span>
        <br />
        <span>Email: info@kiefrealty.com</span>
      </div>
      <h5>14. MLS Agreements and Disclaimers</h5>
      <p>Disclaimers: Multiple Listing Services and other Data Providers</p>
      <p>
        Kief Realty receives the homes for sale information from Midwest Real
        Estate Data LLC (MRED).
      </p>
    </div>
  </div>
)

export default connect(
  null,
  { openContactModal }
)(TermsOfService)



// WEBPACK FOOTER //
// ./src/views/TermsOfService/index.js